import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface OrderData {
    m_name: string;
    contents: string;
    reg_date: string;
}

interface GetMemberResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: OrderData[];
}

export const useGetOrderHistory = ({ order_idx }: { order_idx: string }): UseQueryResult<GetMemberResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetMemberResponse, Error>({
        queryKey: ["getOrderHistory", order_idx],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_history.replace(":order_idx", order_idx)}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
